import { useState, type MouseEvent } from 'react';
import { Popover, Avatar, Text } from '@kula-ai/components';
import { CenterSpinner } from '@/components/ats';
import { useGetUserGroup, type UserGroupUser } from '@/api';

const PoolMemberRow = ({ member }: { member: UserGroupUser }) => (
  <div className="flex items-center gap-2">
    <Avatar src={member.avatar_url} name={member.name} size="xs" />
    <Text variant="p" truncate>
      {member.name}
    </Text>
  </div>
);

interface InterviewPoolPopoverProps {
  poolId: number;
}

export const InterviewPoolPopover = ({ poolId }: InterviewPoolPopoverProps) => {
  const { userGroup, isLoading } = useGetUserGroup({ id: poolId });
  const members = userGroup?.users ?? [];
  const [open, setOpen] = useState(false);

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <span
      onClick={handleClick}
      onMouseDown={handleClick}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <Popover
        open={open}
        onOpenChange={setOpen}
        side="top"
        align="end"
        sideOffset={8}
        trigger={
          <span className="cursor-pointer text-sm font-medium text-primary-500">
            View Pool
          </span>
        }
      >
        <div className="flex w-48 flex-col gap-1 p-1">
          <Text variant="h3" className="mb-1">
            In this pool
          </Text>
          {isLoading ? (
            <CenterSpinner height="100px" />
          ) : (
            <div className="flex max-h-48 flex-col gap-2 overflow-y-auto">
              {members.map((member) => (
                <PoolMemberRow member={member} key={member.id} />
              ))}
            </div>
          )}
        </div>
      </Popover>
    </span>
  );
};
